<script>
import mineSelect from './mineSelect';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    name: "mineSelect",
    data() {
        return {
            isActive: this.show,
            isTapThis: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
        this.onSelectTap();
        window.addEventListener('click', this.handleBodyClick);
    },
    destroyed() {
        window.removeEventListener('click', this.handleBodyClick);
    },
    watch: {
        show: {
            handler: function (value) { 
                if (typeof value === 'boolean') this.isActive = value;
            },
            immediate: true
        }
    },
    methods: {
        // body点击监听
        handleBodyClick() { 
            this.isActive = false;
        },
        // 监听当前页面所有下拉点击
        onSelectTap() { 
            mineSelect.$on('tap', () => {
                // 点击的不是当前组件
                if (!this.isTapThis) { 
                    // 隐藏下拉
                    this.isActive = false;
                } else {
                    // 是当前组件
                    this.isTapThis = false;
                }
            })
        },
        // 点击value
        tapValue() { 
            this.isActive = !this.isActive;
            this.isTapThis = true;
            mineSelect.$emit('tap');
        },
    },
};
</script>

<template>
    <div class="mine_select" :class="{active: isActive}">
        <div class="value" @click.stop="tapValue"><slot name="value"></slot></div>
        <div class="options"><slot></slot></div>
    </div>
</template>

<style scoped lang="scss">
.mine_select{
    position: relative;
    font-size: .16rem;
    user-select: none;
    width: 100%;
    &.active{
        z-index: 1;
        .value{
            border-radius: .05rem .05rem 0 0;
            z-index: 1;
            &::after{
                transform: translate(-50%, -25%) rotate(-135deg);
            }
        }
        .options{
            display: block;
        }
    }
    .value{
        width: 100%;
        height: .4rem;
        border: 1px solid #333;
        border-radius: .05rem;
        padding: 0 .4rem 0 .1rem;
        // display: flex;
        // align-items: center;
        line-height: .4rem;
        cursor: pointer;
        position: relative;
        &::after{
            content: "";
            width: .1rem;
            height: .1rem;
            border-right: 1px solid #333;
            border-bottom: 1px solid #333;
            position: absolute;
            right: .08rem;
            top: 50%;
            transform: translate(-50%, -75%) rotate(45deg);
        }
    }
    .options{
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        border: 1px solid #333;
        border-top: none;
        border-radius: 0 0 .05rem .05rem;
        background: #fff;
        display: none;
        max-height: 2.5rem;
        overflow-y: auto;
        // .option{
        //     padding: 0 .1rem;
        //     height: .35rem;
        //     cursor: pointer;
        //     line-height: .35rem;
        //     cursor: pointer;
        //     &.active,
        //     &:hover{
        //         background: #f1f1f1;
        //     }
        // }
    }
}
</style>